export default "__VITE_ASSET__CSJ8ymw4__"